import { z } from 'zod';

/**
 * What the address of Plan and credits may carry: where the browser came back from, the hosted
 * checkout page for a first plan (`success`, `cancelled`) or a switch in place for a company already
 * paying by card (docs/runbooks/stripe.md), and the return from paying for a credit pack. Stripe
 * sends the browser to `/settings/billing?checkout=…`, which opens Plan and credits with these.
 */
export const billingSearch = z.object({
  // A value the page does not know is dropped, never the page: `?checkout=maybe` failed the route.
  checkout: z.enum(['success', 'switched', 'cancelled']).optional().catch(undefined),
  pack: z.enum(['success', 'cancelled']).optional().catch(undefined),
});

export type BillingSearch = z.infer<typeof billingSearch>;

/** Whatever came on the old address, kept where it is understood and dropped where it is not. */
export function billingSearchOf(raw: unknown): BillingSearch {
  const parsed = billingSearch.safeParse(raw);
  return parsed.success ? parsed.data : {};
}
